export const MAX_PERSISTENT_MENU_ITEMS_COUNT = 10;

export const MAX_CALL_TO_ACTION_ITEMS_COUNT = 3;
